import { Button } from '@/components/ui/button';
import MinusIcon from '@/public/images/ic_minus_button.svg';
import Image from 'next/image';
import React from 'react';

function MinusButton({
  onClick,
  disabled,
}: {
  onClick: any;
  disabled?: boolean;
}) {
  return (
    <Button
      className={`w-6 h-6 relative p-0 bg-[#FF7395] rounded-none hover:bg-[#FF7395] ${disabled && 'bg-[#EEEEEE]'}`}
      onClick={onClick}
    >
      <Image src={MinusIcon} alt="minus" fill />
    </Button>
  );
}

export default MinusButton;
